import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import {
  Button,
  DocumentsList,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";

//

import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeeByUiidStart,
  setEmployeeProfileUiid,
} from "../../../../../redux/slices/employee/employeeSlice";
import { getValueByKey, dateFormator } from "../../../../../utils";
import PassportModal from "./WorkAuthorizationModals/PassportModal";
import { transformFiles } from "../../../../../utils/transformFiles";
import dayjs from "dayjs";

const Passport = ({ handleEditPassPort }) => {
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const handleEdit = () => {
    setIsEditModalOpen(true);
  };

  const handleClose = () => {
    setIsEditModalOpen(false);
  };

  useEffect(() => {
    if (employeeProfileUiid && !loadedTabs.includes("passportTab")) {
      dispatch(
        getEmployeeByUiidStart({
          uiid: employeeProfileUiid,
          tab: "passportTab",
          ret: "passport",
          ref: "passportDoc",
        })
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  const { passport } = employeeDetails || {};
  ///
  // Update the handler function
  // Update the handler function
  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsModalOpen(true);
  };

  //const tableData = passport.length > 0 ? [passport] : [];
  //const tableData = passport && Object.keys(passport).length > 1 ? [passport] : [];
  const tableData = passport || [];

  const columns = [
    { key: "number", label: "Passport Number" },
    { key: "issuedAt", label: "Place of Issue" },
    {
      key: "issueDate",
      label: "Issued Date",
      render: (row) => dateFormator(row.issueDate, "month-day-year"),
    },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate, "month-day-year"),
    },
   {
  key: "status",
  label: "Status",
 render: (row) => {
  const expiryDate = dayjs(row.expiryDate);
  const now = dayjs(); // use dayjs here too
  const isExpired = expiryDate.isBefore(now, "day"); // compares by day
  const statusLabel = isExpired ? "Expired" : "Active";
  return <StatusTags tag={statusLabel} />;
}
},

    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              transformFiles(row.documents).length > 0 && "cursor-pointer"
            }`}
            onClick={
              transformFiles(row.documents).length > 0
                ? () => handelDocumetsModal(transformFiles(row.documents))
                : () => {}
            }
          >
            <span
              className={`${
                transformFiles(row.documents).length > 0 && "text-linkblue"
              }`}
            >
              {transformFiles(row.documents).length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
    },
    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div>
            <Button
              type="icon"
              size="sm"
              color="dark"
              variant="text"
              icon="edit_square"
              onClick={() => handleEditPassPort(row)}
            />
          </div>
        );
      },
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_workauthorization_passport`} rows={mappedRows} columns={columns}  />
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        {console.log("selectedDocuments", selectedDocuments)}
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <PassportModal isOpen={isEditModalOpen} onClose={handleClose} edit />
    </div>
  );
};

export default Passport;
